module.exports = __webpack_public_path__ + "static/media/rustore_badge_ru_color_40.a444ea58.svg";